import { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

import { DEBOUNCE_TIME } from '../../constants/queryParams';
import { useAccountLocationsQuery, useLocationsQuery } from '../../hooks/useLocationsQuery';
import { formatAddressWithAddress2 } from '../../utils/helpers/location';

export const PLACES_RESOURCE_TYPE = 'googlePlaces';
export const ACCOUNT_LOCATIONS_RESOURCE_TYPE = 'accountLocations';

export const useLocationOptions = ({ accountId }) => {
  const [query, setQuery] = useState<string>();
  const { data: locationsResult, isFetching: isFetchingPlacesLocations } = useLocationsQuery({
    q: query || '',
  });
  const { data: accountLocationsResult, isFetching: isFetchingAccountLocations } = useAccountLocationsQuery({
    accountId: accountId,
    q: query || '',
  });

  const locationOptions =
    locationsResult?.data?.map((location) => ({
      label: location?.description,
      value: location?.placeId,
      resourceType: PLACES_RESOURCE_TYPE,
    })) || [];

  const accountLocationOptions =
    accountLocationsResult?.data?.map((location) => ({
      label: location?.name || formatAddressWithAddress2(location?.address, location?.streetAddressTwo),
      value: location?.placeId,
      streetAddressTwo: location?.streetAddressTwo,
      resourceType: ACCOUNT_LOCATIONS_RESOURCE_TYPE,
    })) || [];

  const debouncedHandleQuerySearch = useMemo(() => debounce(setQuery, DEBOUNCE_TIME), []);

  return {
    debouncedHandleQuerySearch,
    locationOptions,
    accountLocationOptions,
    isFetching: isFetchingPlacesLocations || isFetchingAccountLocations,
  };
};
